"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InjectConnector = void 0;
const protocol_1 = require("../protocol");
const utils_1 = require("../utils");
const iconnector_1 = require("./iconnector");
class InjectConnector {
    constructor() {
        this.disconnectListener = [];
        this.providerMap = new Map();
        this.disconnectHandler = null;
        this.walletName = "";
        this.icon = "";
        this.walletNameKey = '';
        this.enable = true;
    }
    setAccountChangeListener(accountChangeListener) {
        (0, utils_1.logDebug)("setAccountChangeListener: inject", accountChangeListener);
        this.accountChangeListener = accountChangeListener;
    }
    setConnectionManager(connectionManager) {
        this.connectionManager = connectionManager;
    }
    getInjectProvider(nameSpace) {
        if (!nameSpace)
            return;
        for (const [mapKey, value] of this.providerMap.entries()) {
            if (nameSpace.includes(mapKey)) {
                return value;
            }
        }
        return undefined;
    }
    send(request, requestAnswer) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                (0, utils_1.logDebug)("InjectEngine send  > request:", (0, utils_1.safeJsonStringify)(request));
                let newRequest = request;
                if (newRequest.method === 'disconnect') {
                    yield this.disconnect();
                    this.disconnectListener.forEach(listener => listener());
                    this.disconnectListener = [];
                    (_a = requestAnswer.onAck) === null || _a === void 0 ? void 0 : _a.call(requestAnswer);
                    return;
                }
                yield this.checkWalletMatch();
                const injectProvider = this.getInjectProvider((0, utils_1.getNamespaceKeyByChain)(newRequest.chainId));
                if (injectProvider) {
                    injectProvider.send(newRequest).then(result => {
                        var _a;
                        (0, utils_1.logDebug)("InjectEngine ==>> send > result:", result);
                        (_a = requestAnswer.resolve) === null || _a === void 0 ? void 0 : _a.call(requestAnswer, result);
                    }).catch(error => {
                        var _a;
                        let code = error.code;
                        if (code === 4001) {
                            code = protocol_1.OKX_CONNECT_ERROR_CODES.USER_REJECTS_ERROR;
                        }
                        let errorResponse = {
                            requestId: Date.now().toString(),
                            method: request.method,
                            error: {
                                code: code,
                                message: error.message
                            }
                        };
                        (0, utils_1.logDebug)("InjectEngine ==>> send > errorResponse:", JSON.stringify(errorResponse));
                        (_a = requestAnswer.resolve) === null || _a === void 0 ? void 0 : _a.call(requestAnswer, errorResponse);
                    });
                    return;
                }
                else {
                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.CHAIN_NOT_SUPPORTED);
                }
            }
            catch (error) {
                (0, utils_1.logDebug)("InjectEngine ==>> send  ===> error:", error);
                return Promise.reject(error);
            }
        });
    }
    checkWalletMatch() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                var _a;
                let sessionLocal = (_a = this.connectionManager) === null || _a === void 0 ? void 0 : _a.getSessionContent('connectSession');
                if (!sessionLocal) {
                    reject(new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.WALLET_NOT_SUPPORTED));
                }
                this.restoreconnect(sessionLocal, (session) => {
                    if (session) {
                        resolve();
                    }
                    else {
                        reject(new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.WALLET_NOT_SUPPORTED));
                    }
                });
            });
        });
    }
    clearData() {
        this.connectResultListener = undefined;
    }
    addDisconnectListener(disconnecter) {
        this.disconnectListener.push(disconnecter);
    }
    setOnConnectResultListener(connectResultListener) {
        this.connectResultListener = connectResultListener;
    }
    connectManagerDisconnect() {
        return __awaiter(this, arguments, void 0, function* (_ = false) {
        });
    }
    getCurrentConnectionReady(namespaceKeys) {
        if (!namespaceKeys) {
            return false;
        }
        return true;
        // const allReady = namespaceKeys!.every(namespaceKey =>
        //     this.getInjectProvider(namespaceKey)?.connectReady()
        // );
        // return allReady;
    }
    getTag() {
        return iconnector_1.OKX_INJECT_WALLET;
    }
    toJSON() {
        return "inject-connector";
    }
    getSupportNameSpaces() {
        return Array.from(this.providerMap.keys());
    }
}
exports.InjectConnector = InjectConnector;
